import React, { useState } from 'react';

import MetricBox from './MetricBox';

interface FlightTimeRemainingProps {
  seconds: number;
  batteryPercent: number; // 0 to 1
}

const formatHHMMSS = (seconds: number): string => {
  const h = Math.floor(seconds / 3600)
    .toString()
    .padStart(2, '0');
  const m = Math.floor((seconds % 3600) / 60)
    .toString()
    .padStart(2, '0');
  const s = Math.floor(seconds % 60)
    .toString()
    .padStart(2, '0');
  return `${h}:${m}:${s}`;
};

const formatMMMMSS = (seconds: number): string => {
  const m = Math.floor(seconds / 60)
    .toString()
    .padStart(4, '0');
  const s = Math.floor(seconds % 60)
    .toString()
    .padStart(2, '0');
  return `${m}:${s}`;
};

const FlightTimeRemaining: React.FC<FlightTimeRemainingProps> = ({ seconds, batteryPercent }) => {
  const [longFormat, setLongFormat] = useState(false);
  const color: 'normal' | 'warning' | 'danger' =
    batteryPercent < 0.15 ? 'danger' : batteryPercent < 0.3 ? 'warning' : 'normal';
  const display = longFormat ? formatMMMMSS(seconds) : formatHHMMSS(seconds);
  return (
    <MetricBox label='Flight Time Remaining' value={display} color={color} onClick={() => setLongFormat(!longFormat)} />
  );
};

export default FlightTimeRemaining;
